import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ChangePassword: React.FC = () => {
  const [form, setForm] = useState({
    startCode: '',
    userId: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!form.startCode || form.startCode.length < 5 || form.startCode.length > 8) return 'Start code must be 5-8 characters.';
    if (!form.userId || form.userId.length < 8 || form.userId.length > 80) return 'Email/UserId must be 8-80 characters.';
    if (!form.oldPassword || form.oldPassword.length < 6 || form.oldPassword.length > 35) return 'Old password must be 6-35 characters.';
    if (!form.newPassword || form.newPassword.length < 10 || form.newPassword.length > 35) return 'New password must be 10-35 characters.';
    if (!form.confirmPassword || form.confirmPassword.length < 10 || form.confirmPassword.length > 35) return 'Password confirmation must be 10-35 characters.';
    if (form.newPassword !== form.confirmPassword) return 'New password and confirmation do not match.';
    // Regex: bar jedno malo, veliko, broj i spec. karakter
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/.test(form.newPassword)) return 'New password must contain lowercase, uppercase, number and special character.';
    return '';
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg('');
    setError('');
    const validation = validate();
    if (validation) {
      setError(validation);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch('https://TVOJ-API-URL/auth/resetPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (response.status === 200 || response.status === 204) {
        setMsg('Password changed successfully!');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        const data = await response.json();
        switch (response.status) {
          case 400:
            setError('Invalid request. Check your data.');
            break;
          case 401:
            setError('Unauthorized access. Please log in again.');
            break;
          case 403:
            setError('Access denied.');
            break;
          case 404:
            setError('API not found.');
            break;
          case 405:
            setError('Method not allowed.');
            break;
          case 500:
            setError('Server error. Please try again later.');
            break;
          default:
            setError(data.message || 'Request failed.');
        }
      }
    } catch (err) {
      setError('Error communicating with the server.');
    }
    setLoading(false);
  };

  return (
    <Box sx={{ p: 2, pb: { xs: 12, sm: 12, md: 12 }, bgcolor: '#f5f6fa', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={3} sx={{ p: 3, width: '100%', maxWidth: 400 }}>
        <Typography variant="h5" fontWeight={700} color="#1A5FB4" mb={2} align="center">
          Change Password
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Start Code"
            name="startCode"
            value={form.startCode}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            inputProps={{ minLength: 5, maxLength: 8 }}
          />
          <TextField
            label="Email or UserId"
            name="userId"
            value={form.userId}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            inputProps={{ minLength: 8, maxLength: 80 }}
          />
          <TextField
            label="Old Password"
            name="oldPassword"
            type="password"
            value={form.oldPassword}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            inputProps={{ minLength: 6, maxLength: 35 }}
          />
          <TextField
            label="New Password"
            name="newPassword"
            type="password"
            value={form.newPassword}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            inputProps={{ minLength: 10, maxLength: 35 }}
            helperText="Must contain lowercase, uppercase, number and special character."
          />
          <TextField
            label="Confirm New Password"
            name="confirmPassword"
            type="password"
            value={form.confirmPassword}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            inputProps={{ minLength: 10, maxLength: 35 }}
          />
          {error && <Typography color="error" fontSize={14} mt={1}>{error}</Typography>}
          {msg && <Typography color="green" fontSize={14} mt={1}>{msg}</Typography>}
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={loading}>
            {loading ? <CircularProgress size={22} /> : 'Change Password'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default ChangePassword; 